<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="epi"> </p>
<p class="EP">I spend most of my time in California. I feel I am fueled by rage and by the political climate there. I am angry most of the time when I am there, which might be unbearable for someone else, but for me it’s fuel for my writing.</p>
<p class="EPC">—Gore Vidal, from an interview late in his life</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?56424697